// 👇 NO importar del entry "preact-iso" (ese arrastra su prerender)
// import { LocationProvider, Router, Route, hydrate } from 'preact-iso';
import { hydrate } from 'preact';
import { LocationProvider, Router, Route } from 'preact-iso/router'; // 👈 usa solo el router

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { createAppTheme } from '../../shared/components/Theme';

import { Header } from './components/Header.jsx';
import { Home } from './pages/Home/index.jsx';
import { About } from './pages/About/index.jsx';
import { NotFound } from './pages/_404.jsx';

import { AppConfigProvider, useAppConfig } from '../../shared/components/utils/AppConfig';

// SSR compatible con MUI/Emotion:
import { renderToString } from 'preact/compat/server';

function AppWithDynamicTheme() {
  const { appConfig } = useAppConfig();
  
  // Create dynamic theme based on app configuration
  const dynamicTheme = createAppTheme(appConfig?.branding || appConfig?.colors);
  
  return (
    <ThemeProvider theme={dynamicTheme}>
      <CssBaseline />
      <Header />
      <main>
        <Router>
          <Route path="/" component={Home} />
          <Route default component={NotFound} />
        </Router>
      </main>
    </ThemeProvider>
  );
}

export function App(props) {
  const p = props || {};
  const isServer = typeof window === 'undefined';

  return (
    <LocationProvider {...(isServer ? { url: p.url } : {})}>
      <AppConfigProvider roleCode="adevs-welcome">
        <AppWithDynamicTheme />
      </AppConfigProvider>
    </LocationProvider>
  );
}

if (typeof window !== 'undefined') {
  hydrate(<App />, document.getElementById('app'));
}

export async function prerender(data) {
  const html = renderToString(<App url={data && data.url} />);
  return { html, head: '' };
}
